import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=ffcc77e2&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=ffcc77e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcc77e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffcc77e2')) {
      api.createRecord('ffcc77e2', component.options)
    } else {
      api.reload('ffcc77e2', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=ffcc77e2&scoped=true&", function () {
      api.rerender('ffcc77e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PSsnpjNJuLRb/JS/teamMember.vue"
export default component.exports